import { Typography } from 'antd';
import { AIAgentIcon } from 'assets';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { aiAgentCenterMessages } from 'messages';
import React, { memo } from 'react';
import AIAgentCallChatBox from './chat-box-call/AIAgentCallChatBox';
import AIAgentContactInfo from './AIAgentContactInfo';
import AIAgentChatBox from './chat-box-call/AIAgentChatBox';

const AIAgentSupportContent: React.FC = () => {
  const { type } = useAIAgentCenterContext();
  if (type === 'phone') return <AIAgentCallSupportContent />;
  return <AIAgentChatSupportContent />;
};

const AIAgentCallSupportContent: React.FC = () => {
  const { callSession, tab } = useAIAgentCenterContext();

  if (!callSession)
    return (
      <div className='flex h-full w-full flex-1 flex-col items-center gap-6 pt-[200px]'>
        <AIAgentIcon width={128} height={128} />
        <Typography.Text className='max-w-[356px] text-center'>
          {aiAgentCenterMessages.selectCallSession}
        </Typography.Text>
      </div>
    );

  return (
    <div className='flex'>
      <div className='min-w-[200px] flex-1'>
        <AIAgentCallChatBox callSession={callSession} isIntervention={tab !== 'history'} />
      </div>
      <div className='h-[calc(100vh-178px)] w-[468px] border-l'>
        <AIAgentContactInfo key={callSession?.callSessionId} />
      </div>
    </div>
  );
};

const AIAgentChatSupportContent: React.FC = () => {
  const { chatSession, tab } = useAIAgentCenterContext();

  if (!chatSession)
    return (
      <div className='flex h-full w-full flex-1 flex-col items-center gap-6 pt-[200px]'>
        <AIAgentIcon width={128} height={128} />
        <Typography.Text className='max-w-[356px] text-center'>
          {aiAgentCenterMessages.selectChatSession}
        </Typography.Text>
      </div>
    );

  return (
    <div className='flex'>
      <div className='min-w-[200px] flex-1'>
        <AIAgentChatBox isIntervention={tab !== 'history'} />
      </div>
      <div className='h-[calc(100vh-178px)] w-[468px] border-l'>
        <AIAgentContactInfo key={chatSession?.chatSessionId} />
      </div>
    </div>
  );
};

export default memo(AIAgentSupportContent);
